import './styles.scss'
import './help-centre-posts-faq-accordion-picker.js'